<!--
 * @Author: hfxie
 * @Date: 2022-08-30 16:30:40
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-11-29 13:32:57
 * @Description: 单个分类区块·右侧
-->
<template>
  <div class="zone-right">

    <template v-for="(block, blockIndex) in list">
      <div class="zone-content" :key="block.id">
        <!-- 头 -->
        <div
          v-if="block.headerShow === true"
          class="zone-header fixed"
          :class="{
            'no-border-top': blockIndex === 0 && toolbarShow === false
          }"
        >
          <template v-if="header[block.cellKey] instanceof Array">
            <span
              class="zone-header-col"
              v-for="headerItem in header[block.cellKey]"
              :key="headerItem.id"
              :style="{
                'width': headerItem.colWidth + 'px',
                'font-size': headerItem.fontSize + 'px',
                'text-align': headerItem.colAlign,
              }"
            >
              {{headerItem.colCaption}}
              <div class="drag-line-right"></div>
            </span>
            <span class="zone-header-col zone-header-col-exp"></span>
          </template>
        </div>

        <div class="zone-main">
          <div class="zone-title" v-if="block.name"></div>
          <!-- 行 -->
          <template v-if="block.isExpand">
            <template v-for="row in block.child">
              <ZoneRowRight :key="'row-' + row.id" :header="header" :block="block" :row="row" />

            </template>
          </template>

        </div>

      </div>
    </template>


  </div>
</template>

<script>
import ZoneRowRight from "@/components/List/Zone/Right/ZoneRowRight";
export default {
  name: "ZoneRight",
  data() {
    return {

    };
  },
  components: {
    ZoneRowRight,
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    header: {
      type: Object,
      default: () => {
        return {};
      },
    },
    toolbarShow: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  computed: {

  },
  methods: {

  },
};
</script>

<style scoped lang='less'>
.zone-right{
  position: relative;
  width: auto;
  min-width: calc(@minContentWidth - @leftViewWidth); // 310 - 148
  .zone-header{
    width: auto;
    height: 28px;
    margin: 0;
    line-height: 28px;
    box-sizing: border-box;
    padding-left: 32px;
    color: #212121;
    background-color: #F8F8F8;
    border-top: 1px solid #D9D9D9;
    border-bottom: 1px solid #D9D9D9;
    .text-oneline;
    &.no-border-top{
      border-top: 0;
    }
    &.fixed{
      position: sticky;
      z-index: 3;
      top: 0;
      flex-shrink: 0;
      // background-color: #ccc!important;
    }
  }
  .zone-main{
    margin-bottom: 8px;
    .zone-title{ // , .zone-row
      .text-oneline;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      padding-left: 12px;
      color: #212121;
      font-weight: 400;
      .zone-icon{
        color: #666666;
        margin-right: 4px;
        font-size: 12px;
      };
      .zone-icon,span{
        vertical-align: middle;
      }
    }
    .zone-title{
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      font-weight: 500;
    }



    /*.zone-detail{
      width: 100%;
      position: relative;
      background-color: #F0F0F0;
      font-weight: 400;

      .zone-detail-box{
        min-width: @minContentWidth; // 310px;
        height: auto;
        color: #666666;
        box-sizing: border-box;
        padding: 4px 32px;

        .zone-detail-item{
          .text-oneline;
          height: 24px;
          line-height: 24px;
        }

      }

    }*/

  }



  /* 自身 */
  .zone-header{
      padding-left: 0;
    }
  .zone-main{
    .zone-title{
      padding-left: 0;
    }
  }

  .zone-header-col{
    .text-oneline;
    display: inline-block;
    height: 100%;
    // border-right: 1px solid red;
    padding: 0 6px;
    box-sizing: border-box;
    position: relative;
    .drag-line-right{
      width: 4px;
      height: 50%;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      box-sizing: border-box;
      border-right: 1px solid #666666;
      border-right: 1px solid var(--border-color, #666666);
      // cursor: ew-resize;
    }
    &.zone-header-col-exp{
      width: 100px;
    }
  }

}
</style>
